import React from 'react';
import './LikeButton.css';

interface LikeButtonProps {
  isLiked: boolean;
  likeCount: number;
  onClick: () => void;
  disabled?: boolean;
}

const LikeButton: React.FC<LikeButtonProps> = ({ isLiked, likeCount, onClick, disabled = false }) => {
  return (
    <button
      type="button"
      className={`like-button ${isLiked ? 'liked' : ''}`}
      onClick={onClick}
      disabled={disabled}
      title={isLiked ? 'Gefällt mir entfernen' : 'Gefällt mir'}
      style={{
        background: isLiked ? 'rgba(255, 106, 172, 0.12)' : 'rgba(255, 255, 255, 0.03)',
        border: isLiked 
          ? '1px solid rgba(255, 106, 172, 0.3)' 
          : '1px solid rgba(255, 255, 255, 0.08)',
        color: isLiked ? '#ff6aac' : 'var(--text-muted)',
      }}
    >
      <span className="like-icon">{isLiked ? '❤️' : '🤍'}</span>
      <span className="like-count">{likeCount}</span>
    </button>
  );
};

export default LikeButton;

